(ns splash.ui.lender-portal.components.sidebar-card
  (:require
    [splash.ui.lender-portal.components.mui :as mui]
    [splash.ui.lender-portal.components.theme :as theme]))

(defn sidebar-card
  [child]
  [mui/paper {:elevation 3
              :sx {:display "flex"
                   :flex-direction "column"
                   :gap "12px"
                   :align-items "start"
                   :padding "16px 22px"
                   :margin "16px"
                   :backgroundColor theme/catskill-white}}
   child])
